import React from 'react';
import { Card, CardContent, Divider, IconButton, Tooltip } from '@mui/material';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import { ItemCardProps } from './types';
import { ArrowRightAlt, Close, Loop } from '@mui/icons-material';

export const ItemCard: React.FC<ItemCardProps> = ({
  title,
  date,
  doer,
  inspector,
  projects,
  locations,
  onDelete,
  onReschedule,
  onStart,
}) => {
  return (
    <Card className="schedule-card">
      <CardContent className="d-flex h-100 p-0">
        <div className="item-details p-2 d-flex flex-column">
          <div className="date d-flex">
            <CalendarMonthOutlinedIcon />
            <span>{date}</span>
          </div>
          <span className="title">{title}</span>
          <span className="locations">{locations?.join(' | ')}</span>
          <span className="projects">{projects?.join(' | ')}</span>
          <Divider />
          <div className="d-flex justify-content-between flex-grow-1 align-items-center">
            <div>
              <span>Doer :</span>
              <Tooltip title={doer ?? ''} placement="top" arrow>
                <img
                  src={`https://ui-avatars.com/api/?size=24&color=fff&rounded=false&bold=true&background=random&name=${doer}`}
                  className="rounded-circle mx-1"
                  alt=""
                />
              </Tooltip>
            </div>
            <div>
              <span>Inspector :</span>
              <Tooltip title={inspector ?? ''} placement="top" arrow>
                <img
                  src={`https://ui-avatars.com/api/?size=24&color=fff&rounded=false&bold=true&background=random&name=${inspector}`}
                  className="rounded-circle mx-1"
                  alt=""
                />
              </Tooltip>
            </div>
          </div>
        </div>
        <div className="controls-container d-flex flex-column justify-content-between">
          <IconButton size="small" className="action-btn" onClick={onStart}>
            <ArrowRightAlt color="inherit" />
          </IconButton>
          <IconButton size="small" className="action-btn" onClick={onDelete}>
            <Close color="inherit" />
          </IconButton>
          <IconButton
            size="small"
            className="action-btn"
            onClick={onReschedule}
          >
            <Loop color="inherit" />
          </IconButton>
        </div>
      </CardContent>
    </Card>
  );
};
